import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box, Avatar } from '@mui/material';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import profileImage from '../Assets/me.png';

const Header = () => {
    return (
        <AppBar position="static" color="primary" sx={{ boxShadow: 'none', padding: 1 }}>
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                {/* Left Side - Name and Title */}
                <Box display="flex" alignItems="center">
                    <Avatar
                        src={profileImage}
                        alt="Profile Picture"
                        sx={{ width: 56, height: 56, marginRight: 2 }}
                    />
                    <Box>
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Aleksa Lukic
                        </Typography>
                        <Typography variant="subtitle1" color="inherit">
                            Software Engineer
                        </Typography>
                    </Box>
                </Box>
                {/* Right Side - Social Links */}
                <Box>
                    <IconButton
                        color="inherit"
                        href="https://github.com/MicroDev92"
                        target="_blank"
                        aria-label="GitHub"
                    >
                        <GitHubIcon />
                    </IconButton>
                    <IconButton
                        color="inherit"
                        href="https://linkedin.com/in/AleksaLukic"
                        target="_blank"
                        aria-label="LinkedIn"
                    >
                        <LinkedInIcon />
                    </IconButton>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;